import { Button, Checkbox, Hairline } from "@components";

import styles from "@styles/home-configurations.module.scss";

import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
const css = classNames.bind(styles);

const BrandsSection = ({
  section,
  brands,
  onChange,
  onSelect,
  onDrop,
  dropdown,
  sorting,
  onSortItems,
  onDelete,
  sortingItems,
  onCancelSorting,
  collapsedSection,
}) => {
  const [collapsed, setCollapsed] = useState(sortingItems || false);
  const brandMap = new Map(brands.map((brand) => [brand.id, brand]));

  const itemsRef = useRef(null);

  useEffect(() => {
    if (section.id === collapsedSection) setCollapsed(true);
  }, [section, collapsedSection]);

  useEffect(() => {
    if (!itemsRef.current) itemsRef.current = section.items;
  }, [section.items]);

  const moveItem = (index, direction) => {
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= (section.items || []).length) return;

    const newItems = [...section.items];
    const temp = newItems[index];
    newItems[index] = newItems[newIndex];
    newItems[newIndex] = temp;

    onChange({ ...section, items: newItems });
  };

  return (
    <div
      className={css({
        section: true,
        collapsed: collapsed,
      })}
      onClick={() => setCollapsed(!collapsed)}
      key={section.id}
    >
      <div className="d-flex align-center justify-between w-100">
        <div className="d-flex align-center gap-20 w-100">
          <If cond={!sorting && !sortingItems}>
            <Checkbox
              checked={section.active}
              value={true}
              onChange={() => {
                onChange({
                  ...section,
                  active: !section.active,
                });
              }}
              disabled={!section.items || section.items.length === 0}
            />
          </If>
          <div className="d-flex align-center justify-between w-100">
            <div className="d-flex flex-column">
              <p className={styles.title}>{section.title}</p>
              <span className={styles.type}>Seção de marcas</span>
            </div>
            <If cond={sortingItems}>
              <div className="d-flex align-center">
                <Button
                  design="primary"
                  className="mr-10"
                  onClick={onCancelSorting}
                >
                  Salvar ordenação
                </Button>
                <Button
                  onClick={() => {
                    onChange({ ...section, items: itemsRef.current });
                    onCancelSorting();
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </If>
          </div>
        </div>

        <If cond={!sorting && !sortingItems}>
          <div className="d-flex align-center">
            <div
              className={styles.dropdown}
              onClick={(e) => {
                onDrop(dropdown === section.id ? null : section.id);
                e.stopPropagation();
              }}
            >
              <div className={styles.action}>
                <i className="fal fa-ellipsis-v" />
              </div>

              <div
                className={css({
                  dropdownOptions: true,
                  in: dropdown === section.id,
                  out: dropdown !== section.id,
                })}
              >
                <ul className={styles.options}>
                  <li onClick={() => onSelect(section)}>Editar</li>
                  <If cond={(section.items || []).length > 0}>
                    <li onClick={() => onSortItems(section)}>Ordenar itens</li>
                  </If>
                  <li onClick={() => onDelete(section)}>Excluir</li>
                </ul>
              </div>
            </div>
            <div className={styles.hairline} />
            <div className={styles.collapse}>
              {collapsed ? (
                <i className="far fa-chevron-up" />
              ) : (
                <i className="far fa-chevron-down" />
              )}
            </div>
          </div>
        </If>
      </div>

      <If cond={collapsed && (section.items || []).length > 0}>
        <Hairline className="mt-15 mb-0" />
        <div className={styles.brandsItems}>
          {(section.items || []).map((brandId, index) => {
            const brand = brandMap.get(brandId);

            return (
              <div className={styles.brand} key={brand.id}>
                <div className="d-flex align-center">
                  <div className={styles.image}>
                    {brand.logo && <img src={brand.logo} alt={brand.name} />}
                  </div>
                  <p className={styles.name}>{brand.name}</p>
                </div>

                <If cond={sortingItems}>
                  <div className="d-flex align-center gap-10">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveItem(index, 1);
                      }}
                      disabled={index === section?.items.length - 1}
                      type="button"
                      className={styles.moveDown}
                    >
                      <i className="fas fa-chevron-down" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveItem(index, -1);
                      }}
                      disabled={index === 0}
                      type="button"
                      className={styles.moveUp}
                    >
                      <i className="fas fa-chevron-up" />
                    </button>
                  </div>
                </If>
              </div>
            );
          })}
        </div>
      </If>
    </div>
  );
};

export default BrandsSection;
